<template>
  <v-card class="ma-auto custom-card">
    <v-img cover src="../assets/hero_image.jpeg">
      <div class="text-center">
        <!-- Enhanced Header Text -->
        <div class="text-white main-heading mt-8">
          <p class="headline-text">
            The best place to buy your house, sell your car or find a job in
            Somalia
          </p>
        </div>

        <div class="mt-4 mx-5 text-light-color">
          <v-card class="ma-5 mx-auto search-card" outlined>
            <v-row class="mt-8 opacity-100 search-row">
              <div class="searching-in font-medium text-light-color mb-3">
                Searching in
              </div>
              <v-tabs
                v-model="selectedCategory"
                class="category-tabs mb-5 no-grow-tabs"
                center-active
              >
                <!-- Add "All" tab -->
                <v-tab
                  class="tab-item category-tab-item auto-width-tab font-medium"
                  :class="{
                    'tab-item--active': selectedCategory === null,
                  }"
                  @click="handleCategorySelect(null)"
                  hide-slider
                >
                  All
                </v-tab>

                <template v-if="categories.length">
                  <v-tab
                    v-for="category in categories"
                    :key="category.slug"
                    class="tab-item auto-width-tab font-medium"
                    :class="{
                      'tab-item--active':
                        selectedCategory?.slug === category.slug,
                    }"
                    @click="handleCategorySelect(category)"
                    hide-slider
                  >
                    {{ category.name }}
                  </v-tab>
                </template>
                <template v-else>
                  <v-tab disabled class="font-regular"
                    >No categories available</v-tab
                  >
                </template>
              </v-tabs>

              <!-- Enhanced Search Bar -->

              <v-col cols="10" class="search-column pa-0">
                <!-- Search Input -->
                <v-text-field
                  v-model="searchQuery"
                  :placeholder="
                    storesInitialized
                      ? `Search in ${
                          selectedCategory?.name || 'All Categories'
                        }`
                      : 'Loading...'
                  "
                  prepend-inner-icon="mdi-magnify"
                  variant="solo"
                  class="ml-8 text-white search-input font-regular"
                  clearable
                  :disabled="!storesInitialized"
                  @input="debouncedHandleSearch"
                  @click:clear="clearSearch"
                  @keydown.enter="performSearch"
                />
              </v-col>

              <!-- Improved Search Button -->
              <v-col cols="auto" class="search-button-column">
                <v-btn
                  class="search-button button-text"
                  size="x-large"
                  elevation="2"
                  :disabled="!storesInitialized"
                  @click="performSearch"
                  style="
                    height: 55px !important;
                    background-color: darkgoldenrod;
                    text-transform: none !important;
                    color: whitesmoke;
                  "
                >
                  <span class="search-button-text">{{
                    storesInitialized ? "Search" : "Loading..."
                  }}</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </div>
      </div>
    </v-img>

    <!-- Teleported dropdown that breaks out of parent containers -->
    <Teleport to="body">
      <div
        v-if="
          searchQuery.trim().length > 0 &&
          (filteredListings.length > 0 || !storesInitialized)
        "
        :class="[
          'global-dropdown-container',
          {
            visible:
              searchQuery.trim().length > 0 &&
              (filteredListings.length > 0 || !storesInitialized),
          },
        ]"
        :style="dropdownPositionStyle"
      >
        <v-card class="global-search-dropdown" elevation="8">
          <v-list class="global-results-list">
            <!-- Loading state -->
            <v-list-item v-if="!storesInitialized" class="dropdown-item">
              <v-list-item-title class="font-regular text-center">
                <v-progress-circular
                  indeterminate
                  size="20"
                  color="primary"
                ></v-progress-circular>
                <span class="ml-2">Loading...</span>
              </v-list-item-title>
            </v-list-item>

            <!-- No results state -->
            <v-list-item
              v-else-if="filteredListings.length === 0"
              class="dropdown-item"
            >
              <v-list-item-title class="font-regular text-center">
                <span>No results found</span>
              </v-list-item-title>
            </v-list-item>

            <!-- Results list -->
            <!-- <template v-else>
              <v-list-item
                v-for="(item, index) in filteredListings.slice(0, 10)"
                :key="index"
                class="dropdown-item"
                @click="selectListingItem(item)"
                @mouseover="hoveredItem = item.id"
                @mouseleave="hoveredItem = null"
                :class="{ 'dropdown-item--hovered': hoveredItem === item.id }"
              >
                <v-list-item-title class="font-regular">
                  <span v-html="highlightMatch(item.title, searchQuery)"></span>
                </v-list-item-title>
                <v-list-item-subtitle class="dropdown-item-content">
                  <span class="category-label font-medium">
                    {{
                      typeof item.category === "string"
                        ? item.category
                        : item.category?.name
                    }}
                  </span>

                  <span class="match-count font-medium text-xs"
                    >{{ getMatchCount(item) }} Ads</span
                  >
                </v-list-item-subtitle>
              </v-list-item>
            </template> -->

            <!-- Results list (Dubizzle style: terms first, then items) -->
            <template v-else>
              <v-list-item
                v-for="(row, index) in dropdownItems"
                :key="row.id || index"
                class="dropdown-item"
                @click="selectListingItem(row)"
                @mouseover="hoveredItem = row.id"
                @mouseleave="hoveredItem = null"
                :class="{ 'dropdown-item--hovered': hoveredItem === row.id }"
              >
                <v-list-item-title class="font-regular">
                  <span v-html="highlightMatch(row.title, searchQuery)"></span>
                </v-list-item-title>

                <v-list-item-subtitle class="dropdown-item-content">
                  <span class="category-label font-medium">
                    {{
                      row.type === "term"
                        ? selectedCategory?.name || "All"
                        : row.categoryName || "—"
                    }}
                  </span>
                  <span class="match-count font-medium text-xs">
                    {{ row.count }} Ads
                  </span>
                </v-list-item-subtitle>
              </v-list-item>
            </template>
          </v-list>
        </v-card>
      </div>
    </Teleport>
  </v-card>
</template>

<script setup>
import { useFont } from "@/composables/useFont";
import { debounce } from "lodash";
import { computed, nextTick, onMounted, onUnmounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

const store = useStore();
const router = useRouter();
const route = useRoute();
const searchQuery = ref("");
const selectedCategory = ref(null);
const loading = ref(false);
const dropdownPositionStyle = ref({});
const searchInputEl = ref(null);
const hoveredItem = ref(null);
const storesInitialized = ref(false);
const { fontClasses } = useFont();

const clearPropertySearchState = async () => {
  try {
    // Clear property-related category state
    await store.dispatch("NewCategory/clearSelectedCategory");
    await store.dispatch("NewCategory/clearSubcategories");

    // Reset property filter store completely
    await store.dispatch("propertyFilter/resetFilters");

    // Ensure FilterStore is clean for general search
    await store.dispatch("FilterStore/resetFilters");
  } catch (error) {
    console.warn("Error clearing property search state:", error);
  }
};

// --- NEW: local keyword index built from titles + subcats/groups (lightweight) ---
const indexTerms = ref([]);

/** Build a small index of useful terms (titles, subcategories, groups) */
const buildSearchIndex = () => {
  try {
    const general = store.state.FilterStore?.allListings || [];
    const property = store.state.propertyFilter?.propertyListings || [];
    const all = Array.isArray(general) ? general.slice() : [];
    if (Array.isArray(property)) {
      property.forEach((p) => {
        if (!all.some((x) => x.id === p.id)) all.push(p);
      });
    }

    const terms = new Set();

    // titles → split + keep 1–2 word phrases that look meaningful (3+ chars)
    all.forEach((l) => {
      const title = (l?.title || "").toLowerCase();
      if (!title) return;

      // single words
      title.split(/\s+/).forEach((w) => {
        if (w.length >= 3) terms.add(w);
      });

      // simple 2-grams
      const words = title.split(/\s+/).filter((w) => w.length >= 3);
      for (let i = 0; i < words.length - 1; i++) {
        const bigram = `${words[i]} ${words[i + 1]}`.trim();
        if (bigram.length >= 5) terms.add(bigram);
      }
    });

    // add subcategories / groups if you have them in store
    try {
      const cats = store.getters["NewCategory/categories"] || [];
      cats.forEach((c) => {
        (c?.subCategories || c?.subcategories || []).forEach((sc) => {
          const t = (sc?.name || sc?.title || "").toLowerCase();
          if (t && t.length >= 3) terms.add(t);
          (sc?.groups || []).forEach((g) => {
            const gname = (g?.name || g?.title || "").toLowerCase();
            if (gname && gname.length >= 3) terms.add(gname);
          });
        });
      });
    } catch {}

    indexTerms.value = Array.from(terms).slice(0, 1200); // cap for safety
  } catch {
    indexTerms.value = [];
  }
};

/** Count ads that match a keyword (optionally within a category) */
// const countByKeyword = (kw, categoryId = null) => {
//   try {
//     const q = String(kw || "")
//       .toLowerCase()
//       .trim();
//     if (!q) return 0;

//     const generalListings =
//       store.getters["FilterStore/filteredListings"]?.({}) || [];
//     const propertyListings =
//       store.getters["propertyFilter/filteredPropertyListings"]?.({}) || [];

//     const merged = [
//       ...generalListings,
//       ...propertyListings.filter(
//         (p) => !generalListings.some((g) => g.id === p.id)
//       ),
//     ];

//     return merged.filter((l) => {
//       // optional category constraint
//       if (categoryId) {
//         const cid = l.category?.id || l.category_id;
//         if (String(cid) !== String(categoryId)) return false;
//       }

//       const t = (l.title || "").toLowerCase();
//       const d = (l.description || "").toLowerCase();
//       const tagHit =
//         Array.isArray(l.tags) &&
//         l.tags.some((tag) => {
//           const s = typeof tag === "string" ? tag : tag?.name || "";
//           return s.toLowerCase().includes(q);
//         });

//       return t.includes(q) || d.includes(q) || tagHit;
//     }).length;
//   } catch {
//     return 0;
//   }
// };

const countByKeyword = (kw, categoryId = null) => {
  try {
    const q = normalizeKeyword(kw);
    if (!q) return 0;

    // use ALL inventory, not already-filtered getters
    const general = store.state.FilterStore?.allListings || [];
    const property = store.state.propertyFilter?.propertyListings || [];
    const merged = [
      ...general,
      ...property.filter((p) => !general.some((g) => g.id === p.id)),
    ];

    return merged.filter((l) => {
      if (categoryId) {
        const cid = l.category?.id || l.category_id;
        if (String(cid) !== String(categoryId)) return false;
      }
      const t = (l.title || "").toLowerCase();
      const d = (l.description || "").toLowerCase();
      const tagHit =
        Array.isArray(l.tags) &&
        l.tags.some((tag) => {
          const s = typeof tag === "string" ? tag : tag?.name || "";
          return s.toLowerCase().includes(q);
        });
      return t.includes(q) || d.includes(q) || tagHit;
    }).length;
  } catch {
    return 0;
  }
};

/** Clean keyword (trim, remove punctuation between words) */
const normalizeKeyword = (s = "") =>
  String(s)
    .replace(/[,|•\-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const termSuggestions = computed(() => {
  const q = normalizeKeyword(searchQuery.value).toLowerCase();
  if (!q || !storesInitialized.value) return [];

  const starts = [],
    contains = [];
  indexTerms.value.forEach((t) => {
    if (t.startsWith(q)) starts.push(t);
    else if (t.includes(q)) contains.push(t);
  });

  const picked = [
    ...starts.slice(0, 6),
    ...contains.slice(0, 6 - starts.length),
  ];
  const catId = selectedCategory.value?.id || null;

  return picked
    .map((term) => ({
      type: "term",
      id: `term-${term}`,
      title: term,
      count: countByKeyword(term, catId), // ← real count
    }))
    .filter((row) => row.count > 0); // ← hide zero-count terms
});

/** Keep your existing filteredListings; expose as listingSuggestions with counts */
const listingSuggestions = computed(() => {
  const items = filteredListings.value || [];
  return items
    .slice(0, 10)
    .map((it, i) => ({
      type: "listing",
      id: it.id ?? `l-${i}`,
      raw: it,
      title: it.title,
      categoryName:
        typeof it.category === "string" ? it.category : it.category?.name,
      count: getMatchCount(it),
    }))
    .filter((row) => row.count > 0);
});

/** Merge exactly like Dubizzle: terms first, then items */
const dropdownItems = computed(() => {
  return [
    ...termSuggestions.value,
    ...listingSuggestions.value.slice(
      0,
      Math.max(0, 10 - termSuggestions.value.length)
    ),
  ];
});

// Computed properties using Vuex getters with safe fallbacks
// const categories = computed(() => {
//   try {
//     return store.getters['NewCategory/categories'] || [];
//   } catch (error) {
//     return [];
//   }
// });

const categories = computed(() => {
  try {
    const list = store.getters["NewCategory/categories"] || [];
    const EXCLUDED = new Set([7, 8]);
    return list.filter((c) => !EXCLUDED.has(Number(c?.id)));
  } catch {
    return [];
  }
});

watch(
  () => route.path,
  () => {
    // Reset to "All" tab when route changes
    selectedCategory.value = null;
  }
);

// Watch for store initialization
watch(
  () => storesInitialized.value,
  (initialized) => {
    if (initialized) {
      nextTick(() => {
        updateDropdownPosition();
      });
    }
  }
);

// Watch for store data changes to refresh match counts
watch(
  () => [
    store.state.FilterStore?.allListings?.length,
    store.state.propertyFilter?.propertyListings?.length,
  ],
  () => {
    if (storesInitialized.value && searchQuery.value.trim().length > 0) {
      // Force reactivity update
      nextTick(() => {
        // This will trigger the computed properties to recalculate
      });
    }
  },
  { deep: true }
);

// ✅ ENHANCED: Watch for route query changes to ensure proper state clearing
watch(
  () => route.query,
  async (newQuery, oldQuery) => {
    // If category was removed from query, ensure stores are cleared
    if (oldQuery?.category && !newQuery?.category) {
      try {
        await store.dispatch("FilterStore/resetFilters");
        await store.dispatch("NewCategory/clearAllCategoryState");

        // Reset local category selection
        selectedCategory.value = null;
      } catch (error) {
        console.warn("⚠️ Failed to clear stores on route change:", error);
      }
    }
  },
  { deep: true }
);

// Enhanced filteredListings computed property that safely handles both stores
const filteredListings = computed(() => {
  if (!searchQuery.value || searchQuery.value.trim().length === 0) {
    return [];
  }

  // Check if stores are initialized and have data
  if (!storesInitialized.value || !storesHaveData.value) {
    return [];
  }

  try {
    const query = searchQuery.value.trim().toLowerCase();
    const category = selectedCategory.value;

    // Safely get listings from both stores with fallbacks
    const allGeneralListings = store.state.FilterStore?.allListings || [];
    const allPropertyListings =
      store.state.propertyFilter?.propertyListings || [];

    // Ensure we have arrays
    const generalListings = Array.isArray(allGeneralListings)
      ? allGeneralListings
      : [];
    const propertyListings = Array.isArray(allPropertyListings)
      ? allPropertyListings
      : [];

    // Merge listings from both stores, deduplicate by id
    const allListings = [
      ...generalListings,
      ...propertyListings.filter(
        (prop) => !generalListings.some((gen) => gen.id === prop.id)
      ),
    ];

    if (allListings.length === 0) {
      return [];
    }

    return allListings.filter((item) => {
      if (!item || typeof item !== "object") return false;

      // Search in title, description, and tags
      const titleMatch = (item.title || "").toLowerCase().includes(query);
      const descMatch = (item.description || "").toLowerCase().includes(query);
      const tagsMatch =
        Array.isArray(item.tags) &&
        item.tags.some((tag) => {
          const tagString = typeof tag === "string" ? tag : tag?.name || "";
          return tagString.toLowerCase().includes(query);
        });

      const queryMatches = titleMatch || descMatch || tagsMatch;
      if (!queryMatches) return false;

      // Filter by category if selected
      if (category && category.id) {
        const itemCategoryId = item.category?.id || item.category_id;
        if (!itemCategoryId || String(itemCategoryId) !== String(category.id))
          return false;
      }

      return true;
    });
  } catch (error) {
    console.error("❌ Error in filteredListings computed:", error);
    return [];
  }
});
const isLoading = computed(() => {
  try {
    return store.getters["FilterStore/isLoading"] || false;
  } catch (error) {
    return false;
  }
});

const hasActiveFilters = computed(() => {
  try {
    return store.getters["FilterStore/hasActiveFilters"] || false;
  } catch (error) {
    return false;
  }
});

// Check if stores have data
const storesHaveData = computed(() => {
  try {
    if (!storesInitialized.value) return false;

    const generalListings = store.state.FilterStore?.allListings || [];
    const propertyListings = store.state.propertyFilter?.propertyListings || [];

    return generalListings.length > 0 || propertyListings.length > 0;
  } catch (error) {
    return false;
  }
});

// Fetch initial data on component mount

onMounted(async () => {
  try {
    selectedCategory.value = null;
    storesInitialized.value = false;

    // ✅ FIX: Safely dispatch store actions with error handling
    const catPromise = store.dispatch("NewCategory/fetchCategories");
    const filterPromise = store.dispatch("FilterStore/initialize");
    const propertyPromise = store.dispatch("propertyFilter/initialize");

    // Add timeout fallback to prevent infinite waiting
    const timeoutPromise = new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, 10000); // 10 second timeout
    });

    await Promise.race([
      Promise.all([
        catPromise.catch((error) => {
          console.error("❌ Failed to fetch categories:", error);
          return [];
        }),
        filterPromise.catch((error) => {
          console.error("❌ Failed to initialize FilterStore:", error);
          return null;
        }),
        propertyPromise.catch((error) => {
          console.error("❌ Failed to initialize PropertyFilterStore:", error);
          return null;
        }),
      ]),
      timeoutPromise,
    ]);

    // Mark stores as initialized
    storesInitialized.value = true;

    // ✅ FIX: Safely setup event listeners
    if (typeof window !== "undefined") {
      window.addEventListener("resize", updateDropdownPosition);
      window.addEventListener("scroll", updateDropdownPosition);
    }

    // ✅ FIX: Safely update dropdown position
    nextTick(() => {
      try {
        updateDropdownPosition();
      } catch (error) {
        // Silent error handling
      }
    });
  } catch (error) {
    console.error(
      "❌ Error in GeneralSearchFilterCardComponent onMounted:",
      error
    );
    // Even if there's an error, mark as initialized to prevent blocking
    storesInitialized.value = true;
  }

  try {
    buildSearchIndex();
  } catch {}
});

watch(
  () => [
    store.state.FilterStore?.allListings?.length,
    store.state.propertyFilter?.propertyListings?.length,
  ],
  () => {
    if (storesInitialized.value) buildSearchIndex();
  },
  { deep: true }
);

onUnmounted(() => {
  window.removeEventListener("resize", updateDropdownPosition);
  window.removeEventListener("scroll", updateDropdownPosition);
});

const updateDropdownPosition = () => {
  nextTick(() => {
    const searchInput = document.querySelector(".search-input");
    if (searchInput) {
      const rect = searchInput.getBoundingClientRect();
      dropdownPositionStyle.value = {
        position: "fixed",
        top: `${rect.bottom}px`,
        left: `${rect.left}px`,
        width: `${rect.width}px`,
        zIndex: "9999",
      };
    }
  });
};

// Debounced search handler - SIMPLIFIED
const debouncedHandleSearch = debounce(() => {
  // Only proceed if stores are initialized
  if (!storesInitialized.value) {
    return;
  }

  // Only update filters with query and category for dropdown search
  const searchFilters = {
    query: searchQuery.value,
  };

  // Add category if selected
  if (selectedCategory.value) {
    searchFilters.category = selectedCategory.value;
  }

  // Update filters in store with minimal criteria
  try {
    store.dispatch("FilterStore/updateFilters", searchFilters);
  } catch (error) {
    // Silent error handling
  }

  // Update dropdown position
  updateDropdownPosition();
}, 300);

// Optimized handleCategorySelect function
// const handleCategorySelect = async (category) => {
//   // ✅ ENHANCED: Handle null/undefined category selection (All Categories)
//   if (!category) {
//     selectedCategory.value = null;

//     // ✅ CRITICAL: Clear ALL filters when "All" is selected
//     try {
//       // Clear category filters in both stores in the correct order
//       await store.dispatch("FilterStore/resetFilters");
//       await store.dispatch("NewCategory/clearAllCategoryState");

//       // ✅ ADDITIONAL: Ensure complete filter state reset
//       await store.dispatch("FilterStore/updateFilters", {
//         category: null,
//         subcategory: null,
//         query: "",
//         keyword: "",
//       });

//       // ✅ ADD: Clear any route parameters that might persist
//       if (route.query.category || route.query.subcategory) {
//         router.replace({
//           query: {
//             ...route.query,
//             category: undefined,
//             subcategory: undefined,
//           },
//         });
//       }
//     } catch (error) {
//       // Silent error handling
//     }

//     return;
//   }

//   // ✅ FIX: Prevent duplicate selections
//   if (selectedCategory.value && selectedCategory.value.id === category.id) {
//     return;
//   }

//   try {
//     selectedCategory.value = category;

//     // ✅ OPTIMIZATION 1: For property categories, navigate immediately
//     if (
//       category?.slug &&
//       (category.slug === "property-for-sale" ||
//         category.slug === "property-for-rent")
//     ) {
//       // Set basic category info synchronously (no await)
//       store.commit("NewCategory/SET_SELECTED_CATEGORY", category);
//       store.commit("FilterStore/SET_FILTERS", { category });

//       // ✅ OPTIMIZATION 2: Navigate immediately without waiting for API calls
//       router.push({
//         name: "PropertyFilter",
//         params: { categorySlug: category.slug },
//         query: { categoryId: category.id },
//       });

//       // ✅ OPTIMIZATION 3: Let PropertyFilter handle its own data loading
//       // Background updates (non-blocking)
//       Promise.all([
//         store.dispatch("NewCategory/selectCategory", category),
//         store.dispatch("FilterStore/updateFilters", { category }),
//       ]).catch((error) => {
//         // Silent error handling
//       });

//       return; // Exit early for fast navigation
//     }

//     // For non-property categories, use existing logic
//     await store.dispatch("NewCategory/selectCategory", category);
//     await store.dispatch("FilterStore/updateFilters", { category });
//   } catch (error) {
//     console.error("❌ Error in category selection:", error);
//     // Don't block navigation on store errors
//   }
// };

//Might be deleted in  future

const handleCategorySelect = async (category) => {
  // ✅ ENHANCED: Handle null/undefined category selection (All Categories)
  if (!category) {
    selectedCategory.value = null;

    await clearPropertySearchState();

    // ✅ CRITICAL: Clear ALL filters when "All" is selected
    try {
      // Clear category filters in both stores in the correct order
      await store.dispatch("FilterStore/resetFilters");
      await store.dispatch("NewCategory/clearAllCategoryState");

      // ✅ ADDITIONAL: Clear property filter store completely
      await store.dispatch("propertyFilter/resetFilters");

      // ✅ ADDITIONAL: Ensure complete filter state reset
      await store.dispatch("FilterStore/updateFilters", {
        category: null,
        subcategory: null,
        query: "",
        keyword: "",
      });

      // ✅ ADD: Clear any route parameters that might persist
      if (route.query.category || route.query.subcategory) {
        router.replace({
          query: {
            ...route.query,
            category: undefined,
            subcategory: undefined,
          },
        });
      }
    } catch (error) {
      // Silent error handling
    }

    return;
  }

  // ✅ FIX: Prevent duplicate selections
  if (selectedCategory.value && selectedCategory.value.id === category.id) {
    return;
  }

  try {
    selectedCategory.value = category;

    // ✅ OPTIMIZATION 1: For property categories, navigate immediately
    if (
      category?.slug &&
      (category.slug === "property-for-sale" ||
        category.slug === "property-for-rent")
    ) {
      // Set basic category info synchronously (no await)
      store.commit("NewCategory/SET_SELECTED_CATEGORY", category);
      store.commit("FilterStore/SET_FILTERS", { category });

      // ✅ OPTIMIZATION 2: Navigate immediately without waiting for API calls
      router.push({
        name: "PropertyFilter",
        params: { categorySlug: category.slug },
        query: { categoryId: category.id },
      });

      // ✅ OPTIMIZATION 3: Let PropertyFilter handle its own data loading
      // Background updates (non-blocking)
      Promise.all([
        store.dispatch("NewCategory/selectCategory", category),
        store.dispatch("FilterStore/updateFilters", { category }),
      ]).catch((error) => {
        // Silent error handling
      });

      return; // Exit early for fast navigation
    }

    // For non-property categories, use existing logic
    await store.dispatch("NewCategory/selectCategory", category);
    await store.dispatch("FilterStore/updateFilters", { category });
  } catch (error) {
    console.error("❌ Error in category selection:", error);
    // Don't block navigation on store errors
  }
};

const selectListingItem = async (row) => {
  if (!storesInitialized.value) return;
  await clearPropertySearchState();

  // When user picks a TERM → lock results to that keyword (prevents “other items in category”)
  if (row?.type === "term") {
    const keyword = normalizeKeyword(row.title);
    searchQuery.value = keyword;

    const query = {
      q: keyword,
      mode: "keyword", // <— NEW flag your results page/store will use
      source: "dropdown",
    };
    if (selectedCategory.value?.id)
      query.categoryId = selectedCategory.value.id;

    router.push({ name: "searchResults", query });
    return;
  }

  // Otherwise it's a listing suggestion → keep your existing flow
  const item = row.raw || row;
  const isProperty =
    item?.category?.slug === "property-for-sale" ||
    item?.category?.slug === "property-for-rent" ||
    (item?.category?.name &&
      item.category.name.toLowerCase().includes("property")) ||
    !!item?.property;

  const keyword = normalizeKeyword(searchQuery.value || item?.title || "");

  if (isProperty) {
    let categorySlug = item?.category?.slug;
    if (!categorySlug && item?.category?.id) {
      const cats = store.getters["NewCategory/categories"] || [];
      const found = cats.find((c) => String(c.id) === String(item.category.id));
      if (found) categorySlug = found.slug;
    }
    if (!categorySlug && item?.category?.name) {
      const nm = item.category.name.toLowerCase();
      if (nm.includes("sale")) categorySlug = "property-for-sale";
      else if (nm.includes("rent")) categorySlug = "property-for-rent";
    }
    if (!categorySlug) {
      alert("Could not determine property category for navigation.");
      return;
    }

    router.push({
      name: "PropertySearch",
      params: { categorySlug },
      query: {
        q: keyword,
        categoryId: item?.category?.id,
        subcategoryId: item?.subcategory?.id,
        source: "dropdown",
      },
    });
    return;
  }

  //might be uncommnented in future below snippet

  try {
    await store.dispatch("FilterStore/setSelectedListingItem", item);
  } catch {}

  setTimeout(() => {
    router.push({
      name: "searchResults",
      query: {
        q: keyword,
        mode: "keyword", // still keep exact mode for non-property item
        categoryId: item?.category?.id || selectedCategory.value?.id,
        subcategoryId: item?.subcategory?.id || item?.sub_category_id,
        source: "dropdown",
      },
    });
  }, 1000);

  console.log("Navigating to listing item:", item);
};

// ✅ FIXED: Enhanced performSearch function
// const performSearch = () => {
//   // Only proceed if stores are initialized
//   if (!storesInitialized.value) {
//     return;
//   }

//   // Build query parameters
//   const queryParams = {};

//   // Only add query if it's not empty
//   if (searchQuery.value.trim()) {
//     queryParams.q = searchQuery.value.trim();
//   }

//   // ✅ CRITICAL FIX: Only add category if it's selected (not "All")
//   if (selectedCategory.value) {
//     queryParams.category = selectedCategory.value.id;
//   }

//   // ✅ ENHANCED: Ensure complete store state clearing when "All" is selected
//   if (!selectedCategory.value) {
//     // Clear stores in the correct order
//     try {
//       // 1. Clear FilterStore completely
//       store.dispatch("FilterStore/resetFilters");

//       // 2. Clear NewCategory store state
//       store.dispatch("NewCategory/clearAllCategoryState");

//       // 3. Ensure no category parameters are passed
//       delete queryParams.category;
//       delete queryParams.subcategory;
//     } catch (error) {
//       console.warn("⚠️ Failed to clear filter states:", error);
//     }
//   }

//   // Navigate to search results page with clean parameters
//   router.push({
//     name: "searchResults",
//     query: queryParams,
//   });
// };

// const performSearch = () => {
//   if (!storesInitialized.value) return;

//   const queryParams = {};
//   const kw = normalizeKeyword(searchQuery.value);
//   if (kw) {
//     queryParams.q = kw;
//     queryParams.mode = 'keyword';  // <— ensure strict results
//   }
//   if (selectedCategory.value) {
//     queryParams.category = selectedCategory.value.id;
//   } else {
//     try {
//       store.dispatch('FilterStore/resetFilters');
//       store.dispatch('NewCategory/clearAllCategoryState');
//     } catch {}
//   }

//   router.push({ name: 'searchResults', query: queryParams });
// };

const performSearch = async () => {
  if (!storesInitialized.value) return;

  await clearPropertySearchState();
  // Always reset filters when starting a new search
  try {
    store.dispatch("FilterStore/resetFilters");
    if (!selectedCategory.value) {
      store.dispatch("NewCategory/clearAllCategoryState");
    }
  } catch (error) {
    console.warn("Error resetting filters:", error);
  }

  const queryParams = {};
  const kw = normalizeKeyword(searchQuery.value);
  if (kw) {
    queryParams.q = kw;
    queryParams.mode = "keyword";
  }
  if (selectedCategory.value) {
    queryParams.category = selectedCategory.value.id;
    // Also set the category in the store
    store.dispatch("FilterStore/updateFilters", {
      category: selectedCategory.value,
    });
  }

  console.log("Navigating with query params:", queryParams);

  setTimeout(() => {
    // Slight delay to ensure store updates propagate
    router.push({ name: "searchResults", query: queryParams });
  }, 200);
  
};

// Clear search input and filters
const clearSearch = () => {
  searchQuery.value = "";
  debouncedHandleSearch.cancel(); // Cancel pending debounce

  if (storesInitialized.value) {
    try {
      store.dispatch("FilterStore/updateFilters", { query: "" });
    } catch (error) {
      // Silent error handling
    }
  }
};

// Enhanced highlighting function
const highlightMatch = (text, query) => {
  if (!query || !text) return text || "";

  const tokens = query
    .trim()
    .split(/\s+/)
    .filter((t) => t.length >= 2);
  if (tokens.length === 0) return text;

  const escapedTokens = tokens
    .map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
    .join("|");
  const regex = new RegExp(`(${escapedTokens})`, "gi");
  return text.replace(regex, '<span class="highlight-match">$1</span>');
};

/**
 * Get the count of matches for an item based on category or type
 * This function calculates real-time counts from both FilterStore and PropertyFilterStore
 * @param {Object} item - The listing item
 * @returns {string|number} - Formatted count of matches
 */
const getMatchCount = (item) => {
  try {
    // Check if stores are initialized and have data
    if (!storesInitialized.value || !storesHaveData.value) {
      return 1;
    }

    // Get all listings from both stores
    const generalListings =
      store.getters["FilterStore/filteredListings"]({}) || [];
    const propertyListings =
      store.getters["propertyFilter/filteredPropertyListings"]({}) || [];

    // Combine all listings, ensuring no duplicates by ID
    const allListings = [
      ...generalListings,
      ...propertyListings.filter(
        (prop) => !generalListings.some((gen) => gen.id === prop.id)
      ),
    ];

    if (allListings.length === 0) {
      // Fallback to mock counts if no data available
      const mockCounts = {
        motors: 1,
        cars: 1,
        property: 1,
        jobs: 1,
        classifieds: 1,
        default: 1,
      };

      const category =
        typeof item.category === "string"
          ? item.category.toLowerCase()
          : (item.category?.name || "").toLowerCase();

      return mockCounts[category] || mockCounts.default;
    }

    // Determine the category for this item
    const itemCategory =
      typeof item.category === "string"
        ? item.category
        : item.category?.name || "";

    const itemCategoryId =
      typeof item.category === "object" && item.category?.id
        ? item.category.id
        : item.category_id;

    // Count listings in the same category
    let matchingListings = allListings.filter((listing) => {
      // Match by category ID (most reliable)
      if (itemCategoryId && (listing.category_id || listing.category?.id)) {
        const listingCategoryId = listing.category_id || listing.category?.id;
        return String(itemCategoryId) === String(listingCategoryId);
      }

      // Fallback to category name matching
      if (itemCategory) {
        const listingCategory =
          typeof listing.category === "string"
            ? listing.category
            : listing.category?.name || "";
        return itemCategory.toLowerCase() === listingCategory.toLowerCase();
      }

      return false;
    });

    // If we have subcategory info, be more specific
    const itemSubcategory = item.subcategory?.id || item.sub_category_id;
    if (itemSubcategory) {
      const subcategoryMatches = matchingListings.filter((listing) => {
        const listingSubcategory =
          listing.subcategory?.id ||
          listing.sub_category_id ||
          listing.subcategory_id;
        return String(itemSubcategory) === String(listingSubcategory);
      });

      // Use subcategory count if we have matches, otherwise use category count
      if (subcategoryMatches.length > 0) {
        matchingListings = subcategoryMatches;
      }
    }

    // For very specific searches (like model names), check title matches
    const itemTitle = (item.title || "").toLowerCase();
    if (itemTitle) {
      // Extract potential model/brand keywords from title
      const titleWords = itemTitle
        .split(/\s+/)
        .filter((word) => word.length > 2);

      if (titleWords.length > 0) {
        const titleMatches = matchingListings.filter((listing) => {
          const listingTitle = (listing.title || "").toLowerCase();
          return titleWords.some((word) => listingTitle.includes(word));
        });

        // If we have title matches and they're a smaller subset, use those
        if (
          titleMatches.length > 0 &&
          titleMatches.length < matchingListings.length
        ) {
          matchingListings = titleMatches;
        }
      }
    }

    // const finalCount = Math.max(matchingListings.length, 1); // Always show at least 1

    // return finalCount;

    return matchingListings.length; // no floor
  } catch (error) {
    return 1; // Fallback to 1 if there's an error
  }
};
</script>

<style scoped>
/* Base card styling */
.custom-card {
  background-color: rgba(0, 0, 0, 0.6);
  overflow: visible !important; /* Ensure dropdown can overflow */
}

/* Enhanced header styling */
.main-heading {
  margin-bottom: 1rem;
}

.headline-text {
  font-size: 1.6rem;
  font-weight: 900;
  letter-spacing: 0.5px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  transition: all 0.3s ease;
  line-height: 1.2;
}

.headline-text:hover {
  color: rgba(255, 255, 255, 1);
  transform: scale(1.01);
  text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.7);
}

/* Improved category tabs */
.tabs-container {
  display: flex;
  justify-content: center;
  margin-bottom: 0.5rem;
}

.category-tabs {
  display: flex;
  justify-content: center;
  padding: 0 1rem;

  border-radius: 25px;
  max-width: 100%;

  gap: 10px;
}

.tab-item {
  padding: 10px 24px;
  border-radius: 25px;
  font-weight: bold;
  font-size: 0.9rem;
  color: white;
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
}

.tab-item:hover {
  border-radius: 50px !important;
  /* background-color: red; */
  background-color: darkgoldenrod;
  color: white;
  transform: translateY(-1px);
}

.tab-item--active {
  /* background-color: rgb(220, 20, 20); */
  background-color: darkgoldenrod;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border-radius: 50px !important;
}

/* Search card and input styling */
.search-card {
  background-color: rgba(0, 0, 0, 0.4) !important;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  padding: 0.5rem 0;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
}

.search-row {
  align-items: center;
  margin-bottom: 4px; /* Add some bottom margin */
}
.search-column {
  position: relative;
  padding-right: 0; /* Reduce spacing between input and button */
}

.search-input {
  border-radius: 8px;
  margin-top: 2px; /* Fine-tune vertical alignment */
}

/* Search button styling */
.search-button-column {
  display: flex;
  align-items: center;
  margin-top: -4px; /* Move button up */
}

.search-button {
  height: 52px !important; /* Slightly bigger */
  width: 120px !important; /* Control width */
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  position: relative;
  padding: 0 !important; /* Remove default padding */
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -14px !important;
}

.search-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
  background-color: darkgoldenrod !important;
}

/* .search-button-text {
  font-size: 1rem;
  font-weight: bold;
  letter-spacing: 0.5px;
  text-transform: uppercase;
} */

/* Teleported dropdown styling (global) */
.global-dropdown-container {
  position: fixed;
  z-index: 9999;
  transition: opacity 0.3s ease, transform 0.3s ease;
  opacity: 0;
  transform: translateY(-10px);
  pointer-events: none;
}

.global-dropdown-container.visible {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}

.global-search-dropdown {
  width: 100%;
  max-height: 400px;
  overflow-y: auto;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.global-results-list {
  padding: 8px 0;
}

.dropdown-item {
  padding: 12px 16px;
  cursor: pointer;
  transition: all 0.25s ease-in-out;
  border-left: 3px solid transparent;
  position: relative;
}

.dropdown-item:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.category-label {
  color: #1976d2;
}

/* Add to your existing styles */

/* Style for the item content with match count */
.dropdown-item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.match-count {
  color: #1976d2;
  margin-left: auto;
  background-color: rgba(25, 118, 210, 0.1);
  padding: 2px 8px;
  border-radius: 12px;
  white-space: nowrap;
}

.dropdown-item--hovered,
.dropdown-item:hover {
  background-color: rgba(25, 118, 210, 0.08);
  border-left-color: #1976d2;
  transform: translateX(4px);
}

.dropdown-item:active {
  background-color: rgba(25, 118, 210, 0.15);
  transform: translateX(6px) scale(0.99);
}

/* Highlighted text styling */
.highlight-match {
  background-color: rgba(255, 235, 59, 0.4);
  font-weight: 700;
  color: #000;
  padding: 0 2px;
  border-radius: 3px;
}

/* Loading state styling */
.dropdown-item .v-progress-circular {
  margin-right: 8px;
}

.dropdown-item .text-center {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  color: #666;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .headline-text {
    font-size: 1.5rem;
  }

  .category-tabs {
    max-width: 100%;
  }

  .tab-item {
    font-size: 0.2rem;
    padding: 6px 12px;
  }
}

@media (min-width: 1200px) and (max-width: 1700px) {
  .category-tabs {
    display: flex;
    justify-content: center;
    border-radius: 40px !important;
    max-width: 100%;
    gap: 2px;
  }

  .tab-item {
    font-size: 12px;
  }

  .auto-width-tab {
    flex: 0 0 auto !important;
    width: auto !important;
    min-width: auto !important;
    text-transform: none !important;
    padding: 0 12px;
  }

  .searching-in {
    margin-left: 100px !important;
  }

  .category-tab-item {
    width: 20px;
  }
}

/* Responsive adjustments */
@media (max-width: 1960px) {
  .searching-in {
    margin-left: 150px;
  }
}

.searching-in {
  margin-left: 180px !important;
}

.auto-width-tab {
  flex: 0 0 auto !important;
  width: auto !important;
  min-width: auto !important;
  text-transform: none !important;
  padding: 0 12px;
}
</style>
